import React, { Component } from 'react';
import { string, func, bool } from 'prop-types';
import { Radio, RadioGroup, FormControl, FormControlLabel } from '@material-ui/core';
import { get, isEqual, cloneDeep } from 'lodash';
import styles from './styles.scss';
import classnames from 'classnames';
import { radioOptionsPropsType } from '../../helpers/propTypes';

export default class RadioButtonSelector extends Component {
  static propTypes = {
    options: radioOptionsPropsType.isRequired,
    selectedValue: string,
    isDefaultSelectDisabled: bool,
    onChange: func,
    classname: string,
    formControlClasses: string,
    disabled: bool,
  }

  state = {}

  static getDerivedStateFromProps(props, prevState) {
    const { options, isDefaultSelectDisabled } = props;
    const newState = {...prevState};
    if (!isEqual(options, prevState.options)) {
      newState.options = cloneDeep(options);
      newState.selectedValue = !isDefaultSelectDisabled && get(options, '[0].value');
    }
    return newState;
  }

  handleChange = (e) => {
    const { onChange } = this.props;
    const selectedValue = e.target.value;
    if (selectedValue) {
      onChange && onChange(selectedValue);
      this.setState({ selectedValue });
    }
  }

  drawOptions() {
    const { options, disabled } = this.props;
    return options && options.map((option) => {
      const { name, value } = option;
      const key = `${value}_${name}`;
      return (
        <FormControlLabel
          key={key}
          value={String(value)}
          className={styles.option} 
          control={<Radio data-test="radioBtnOption" className={styles.radio} color="primary"/>} 
          label={name}
          disabled={disabled}
        />
      )  
    });
  }
  
  render() {
    const { classname, selectedValue, formControlClasses } = this.props;
    const { selectedValue: currentValue } = this.state;
    const currentSelect = selectedValue !== undefined? selectedValue : currentValue;

    return (
      <div className={classnames(styles.radioButtonSelector, classname)}>
        <FormControl component="fieldset">
          <RadioGroup
            className={classnames(styles.radioGroup, formControlClasses)}
            value={String(currentSelect)}
            onChange={this.handleChange}
            data-test={"radioBtnSelector" + String(currentSelect)}
          >
            {this.drawOptions()}
          </RadioGroup>
        </FormControl>
      </div>
    )
  }
}
